import React from 'react';
import { CryptodraftProvider } from '../../../contexts/card/cryptodraft/context';
import AddCollateral from './AddCollateral';
import CryptodraftCalculator from './Calculator';
import { cryptodraftScreens } from './constants';
import CryptodarftDetails from './Details';
import CryptodraftInterestPayment from './InterestPayment';
import MainLayout from './partials/MainLayout';
import SettleCryptodraftPayPartial from './PayPartial';
import PaymentCard from './PGW';
import CryptodraftPromo from './Promo';
import ReviewExtendOffer from './ReviewExtendOffer';
import CryptodraftReviewOffer from './ReviewOffer';
import SettleCryptodraft from './Settle';
import Wallets from './Wallets';
import CryptodraftWithdrawCollateral from './Withdraw';

const Cryptodraft = () => (
  <CryptodraftProvider>
    <MainLayout>
      <CryptodraftPromo keyName={cryptodraftScreens.PROMO} />
      <CryptodraftCalculator keyName={cryptodraftScreens.CALCULATOR} />
      <CryptodraftReviewOffer keyName={cryptodraftScreens.REVIEW} />
      <AddCollateral keyName={cryptodraftScreens.ADD_MORE_COLLATERAL} />
      <PaymentCard keyName={cryptodraftScreens.PROCEED_WITH_PAYMENT} />
      <CryptodarftDetails keyName={cryptodraftScreens.DETAILS} />
      <ReviewExtendOffer keyName={cryptodraftScreens.REVIEW_EXTEND_OFFER} />
      <SettleCryptodraft keyName={cryptodraftScreens.SETTLE} />
      <SettleCryptodraftPayPartial keyName={cryptodraftScreens.PAY_PARTIAL} />
      <CryptodraftWithdrawCollateral keyName={cryptodraftScreens.WITHDRAW} />
      <CryptodraftInterestPayment keyName={cryptodraftScreens.INTEREST_PAYMENTS} />
      <Wallets keyName={cryptodraftScreens.WALLETS} />
    </MainLayout>
  </CryptodraftProvider>
);
export default Cryptodraft;
